import { render, staticRenderFns } from "./TelemetryTireTemperatureFlParts.vue?vue&type=template&id=ddff605c&scoped=true"
import script from "./TelemetryTireTemperatureFlParts.vue?vue&type=script&lang=ts"
export * from "./TelemetryTireTemperatureFlParts.vue?vue&type=script&lang=ts"
import style0 from "./TelemetryTireTemperatureFlParts.vue?vue&type=style&index=0&id=ddff605c&prod&lang=scss&scoped=true"
import style1 from "./TelemetryTireTemperatureFlParts.vue?vue&type=style&index=1&id=ddff605c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddff605c",
  null
  
)

export default component.exports